import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import LayoutContainer from '../LayoutContainer';
import ConfrereButton from '../ConfrereButton';
import ContactSupport from '../ContactSupport';

function CheckPermissionsDialog({ open, onClose, streamHandler }) {
  const [checking, setChecking] = useState(false);
  const { t } = useTranslation();

  const requestPermissions = async ({ useAudio = true, useVideo = true }) => {
    if (!(await streamHandler.permissionsRequested())) {
      try {
        await streamHandler.verifyPermission({
          useAudio,
          useVideo,
        });
      } catch (e) {
        if (useAudio && useVideo) {
          // Ask for audio and video separately in sequence
          await requestPermissions({ useAudio: true, useVideo: false });
          await requestPermissions({ useAudio: false, useVideo: true });
        }
      }
    }
  };

  const onCheckPermissions = async () => {
    setChecking(true);
    await requestPermissions({ useAudio: true, useVideo: true });
    onClose();
  };

  if (!open) return null;

  return (
    <LayoutContainer>
      <Grid
        direction="column"
        alignItems="center"
        container
        spacing={2}
        sx={{ maxWidth: '400px' }}
      >
        <Grid item>
          <Typography
            gutterBottom
            align="center"
            sx={{ fontSize: '16px', fontWeight: 'bold' }}
          >
            {t('Grant access to camera and microphone')}
          </Typography>
        </Grid>
        <Grid item>
          <Typography gutterBottom align="center" sx={{ fontSize: '14px' }}>
            {t(
              'Before we can check your devices, you need to allow the website access to your camera and microphone'
            )}
          </Typography>
        </Grid>
        {!checking && (
          <Grid item>
            <ConfrereButton
              onClick={onCheckPermissions}
              sx={{ margin: '8px 16px' }}
              size="small"
            >
              {t('Check for access')}
            </ConfrereButton>
          </Grid>
        )}
        <ContactSupport />
      </Grid>
    </LayoutContainer>
  );
}

export default CheckPermissionsDialog;
